import { ActionSubTypes } from '../../../../actions/ActionSubTypes';
import ApiBaseReducer from '../../../core/ApiBaseReducer';
import pList from '../../../../api/models/pList';
import { rMadenSahalariGenelBilgi } from '../../../../api/models/.catalog';
import { DefaultInputDataStateModel, IInputDataStateModel } from '../../../../models/StateModels';

export default ApiBaseReducer<
  pList,
  IInputDataStateModel<pList, rMadenSahalariGenelBilgi>,
  rMadenSahalariGenelBilgi
>(
  ActionSubTypes.API_MADENSAHALARIGENELBILGI,
  DefaultInputDataStateModel<pList, rMadenSahalariGenelBilgi>()
);
